var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 0H2.1875C0.98125 0 0 0.98125 0 2.1875V7.8125C0 9.01875 0.98125 10 2.1875 10H11.5625C12.7688 10 13.75 9.01875 13.75 7.8125V2.1875C13.75 0.98125 12.7688 0 11.5625 0Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 12.5H2.1875C0.98125 12.5 0 13.4813 0 14.6875V27.8125C0 29.0187 0.98125 30 2.1875 30H11.5625C12.7688 30 13.75 29.0187 13.75 27.8125V14.6875C13.75 13.4813 12.7688 12.5 11.5625 12.5Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8125 20H18.4375C17.2312 20 16.25 20.9813 16.25 22.1875V27.8125C16.25 29.0188 17.2312 30 18.4375 30H27.8125C29.0187 30 30 29.0188 30 27.8125V22.1875C30 20.9813 29.0187 20 27.8125 20Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8125 0H18.4375C17.2312 0 16.25 0.98125 16.25 2.1875V15.3125C16.25 16.5188 17.2312 17.5 18.4375 17.5H27.8125C29.0187 17.5 30 16.5188 30 15.3125V2.1875C30 0.98125 29.0187 0 27.8125 0Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.2dcedcd45ab4f1b28a88798e130072ea.svg";
export { ForwardRef as ReactComponent };